'use client';

import { useId, useLayoutEffect } from 'react';

// adds global style if this hook is used
import '@/react/components/core-ui/hooks/useConditionallyDisableScrolling.scss';

/**
 * Disable document scrolling when condition is `true`.
 *
 * This is primarily used to improve the user experience when a modal or drawer is open.
 * @param condition - A boolean value that determines whether to disable scrolling.
 */
export default function useConditionallyDisableScrolling(
  condition: boolean
): void {
  const id = useId();

  useLayoutEffect(() => {
    if (condition) {
      // To make this hook composable, we must suffix the class name with a unique id,
      // so that multiple instances of this hook can be mounted at the same time.
      document.documentElement.classList.add(`disable-scroll-${id}`);

      return () => {
        document.documentElement.classList.remove(`disable-scroll-${id}`);
      };
    }

    return undefined;
  }, [id, condition]);
}
